<template>
    <div>
        <projetos 
            :projetos="projetos"
            v-show="mostrarProjetos"
            :servicos="obterServicos()"
            @atualizarFiltro="atualizarFiltro($event)"
        >
            <template slot="botoes">
                <b-row class="mt-2">
                    <b-col sm="12">
                        <div class="float-right">
                            <b-form-checkbox
                                v-model="apenasMeusProjetos"
                                :value="true"
                                :unchecked-value="false"
                                ><strong> APENAS MEUS PROJETOS</strong>
                            </b-form-checkbox>
                        </div>
                    </b-col>
                </b-row>
            </template>
            <template slot="acoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('SGTEC-GER-PRJ-01')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharProjeto(data.projetoId)"
                    ></i>
                </span>
            </template>
        </projetos>
        <router-view></router-view>
    </div>
</template>

<script>
import ProjetosServicos from './ProjetosServicos'
import Projetos from '@/app/sgtec/componentes/projetos/Projetos'

export default {
    data() {
        return {
            projetos: [],
            apenasMeusProjetos: true,
            filtro: {
                dataInicial: this.$moment(new Date())
                .startOf('year')
                .format('DD/MM/YYYY'),
                dataFinal: this.$moment(new Date())
                    .endOf('year')
                    .format('DD/MM/YYYY'),
                tipoContratacao: 'TODAS',
                natureza: 'TODAS',
                modulo: "TODOS",
                codSolucao: 0,
            },
        }
    },
    methods: {
        obterServicos() {
            return ProjetosServicos
        },

        atualizarFiltro(filtro) {
            this.filtro = filtro
            this.obterProjetos()
        },
        
        obterProjetos() {
            this.$store.dispatch('addRequest')
            this.filtro.todas = !this.apenasMeusProjetos
            ProjetosServicos.obterTodos(this.filtro).then((response) => {
                if (response) {
                    if (response.success) {
                        this.projetos = response.data
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharProjeto(projetoId) {
            this.$router.push({
                name: 'Sgtec_Gerentes_Projetos_Detalhar',
                params: {
                    projetoId: projetoId
                }
            })
        }
    },

    created() {
    },

    computed: {
        mostrarProjetos() {
            return this.$route.name === 'Sgtec_Gerentes_Projetos'
        }
    },

    components: {
        Projetos: Projetos
    },

    watch: {
        apenasMeusProjetos() {
            this.obterProjetos()
        },

        $route(to) {
            if (to.name === 'Sgtec_Gerentes_Projetos') {
                if (this.$store.getters.recarregar) {
                    this.obterProjetos()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        },
    }
}
</script>
